import { dummyWorkspaceData } from "../common/data/test_workspaceData";
import { getJson, putJson, deleteJson, postJson } from "./ServiceHelperMethods";

class WorkspaceService {

    static async getWorkspaces() {
        console.log("Is function being called?")
        return await getJson(`workspaces`);
    }

    static async getWorkspace(workspaceId) {
        return await getJson(`workspaces/${workspaceId}`);
    }

    static async createWorkspaces(workspaces) {
        return await putJson(`workspaces`, workspaces);
    }

    static async createWorkspace(workspace) {
        const workspaces = await WorkspaceService.createWorkspaces([workspace]);
        return workspaces[0]
    }

    static async deleteWorkspace(workspaceId) {
        return await deleteJson(`workspaces/${workspaceId}`);
    }

    static async startWorkspaceUpgradePaymentIntent(workspace, price) {
        return await postJson(`workspaces/${workspace._id}/initializeUpgrade`, { priceId: price.id });
    }

    static async completeUpgrade(workspace, paymentIntent, subscriptionId) {
        return await postJson(`workspaces/${workspace._id}/completeUpgrade`, { paymentIntent: paymentIntent.id, subscriptionId: subscriptionId });
    }

    static async openBillingPortal(workspaceId, returnUrl) {
        return await postJson(`workspaces/${workspaceId}/billing-portal`, { returnUrl });
    }

    static async sendInvitation(workspaceId, email, role) {
        return await postJson(`workspaces/${workspaceId}/invitations`, { email, role });
    }

    static async getInvitation(token) {
        return await getJson(`public/invitations/${token}`);
    }

    static async acceptInvitation(token) {
        return await postJson(`invitations/${token}/accept`, {});
    }

    static async getWorkspaceActivity(workspaceId, { cursor, limit, verb } = {}) {
        const params = new URLSearchParams();
        if (cursor) params.set('cursor', cursor);
        if (limit) params.set('limit', String(limit));
        if (verb) params.set('verb', verb);
        const qs = params.toString();
        return await getJson(`workspaces/${workspaceId}/activity${qs ? `?${qs}` : ''}`);
    }

    static async getQuota(workspaceId) {
        return await getJson(`workspaces/${workspaceId}/quota`);
    }

    static async updateNotifications(workspaceId, data) {
        return await putJson(`workspaces/${workspaceId}/notifications`, data);
    }
}



export default WorkspaceService;